<template>
  <div>
    <v-select
      v-model="document_category"
      :items="mappedCategories"
      :label="label"
      @input="getSelected"
      class="flex-start"
      :multiple="isMultiple"
      item-text="name"
      item-value="id"
    ></v-select>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  export default {
    props: {
      label: String,
      isMultiple: Boolean,
      resetValues: Boolean,
    },
    data: () => ({
      document_category: [],
    }),
    methods: {
      getSelected() {
        this.$emit("input", this.document_category);
      },
    },
    computed: {
      ...mapState({
        categories: (state) => state.document_categories.document_categories,
      }),
      mappedCategories() {
        // let categories = this.categories.map((n) => {
        //   return n.name;
        // });
        return this.categories;
      },
    },
    watch: {
      resetValues: {
        handler() {
          // console.log(this.resetValues)
          this.document_category = []
        }
      }
    }
  };
</script>
<style>
  .v-text-field__details {
    display: none;
  }
  .v-input__slot {
    margin-bottom: 0 !important;
  }
  .v-input {
    align-items: flex-end  !important;
  }
</style>
